import { OGILayerIds } from '../types';

// checks if given layerId includes any OGILayerId or a specific OGILayerId (if specificLayerId is not falsy)
// Note: function does not check strict equality, only that OGILayerId is included.
export const checkForOGILayerId = (layerId: OGILayerIds | string, specificLayerId?: OGILayerIds) => {
    // checks for a specific layer id
    if (specificLayerId) {
        return layerId.includes(specificLayerId) && layerId.length === specificLayerId.length;
    }
    // checks for any layer id
    return Object.values(OGILayerIds).some((id) => layerId.includes(id) && layerId.length === id.length);
};
